import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';

import { App } from './app';
import { shouldEnableMocking } from './bootstrap';

shouldEnableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
